import React from 'react';
import propTypes from 'prop-types';
import {authenticatedGetRequest} from '../../../helpers/requests';
import StarList from './StarList';

class StarLevel extends  React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stars: null,
            loading: true
        }
    }

    componentWillMount() {
        const personId = localStorage.getItem('person_id');

    this.getStars(personId)
        .then((result) => {
            this.setState({ stars : result, loading: false })
        });
    }

    getStars = async (id) => {
        return authenticatedGetRequest(`/profiles/${id}/star-rating`)
              .then((result) => {
                 return result.data.star_rating ? result.data.star_rating: 0;
              })
            .catch((error) => {
                return 0;
            });
      }

    render() {

        if (!this.state.loading) {
            return (
                <StarList starLevel={this.state.stars}/>
            )
        } else {
            return (
                <div>loading</div>
            )
        }
    }
}

export default StarLevel;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/StarLevel.js